
export default {
    namespaced:true,
    state:{
        jsonControl:[],
        jsonExamen:[],
        jsonDiagnostico:[],
        jsonRecuperativa:[],
        jsonEvaluacion:[],
        jsonEstadoNota:true,
        activeEvaluacion:''
    },
    mutations:{
        cambioJsonControl(state,payload){
            state.jsonControl = payload;
        },
        cambioJsonExamen(state,payload){
            state.jsonExamen = payload;
        },
        cambioJsonDiagnostico(state,payload){
            state.jsonDiagnostico = payload;
        },
        cambioJsonRecuperativa(state,payload){
            state.jsonRecuperativa = payload;
        },
        cambioJsonEvaluacion(state, payload){
            state.jsonEvaluacion = payload;
        },
        cambioJsonEstadoNota(state, payload){
            state.jsonEstadoNota = payload;
        },
        updateActiveEvaluacion(state, payload){
            state.activeEvaluacion = payload;
        },
        updateReinicioNota(state, payload){
            state.jsonEvaluacion.reinicioNota = payload;
        }
    },
    actions:{
        updateControl({commit},payload){
            commit('cambioJsonControl',payload)
        },
        updateActiveEvaluacion({commit},payload){
            commit('updateActiveEvaluacion',payload)
        },
        updateExamen({commit},payload){
            commit('cambioJsonExamen',payload)
        },
        updateDiagnostico({commit},payload){
            commit('cambioJsonDiagnostico',payload)
        },
        updateRecuperativa({commit},payload){
            commit('cambioJsonRecuperativa',payload)
        },
        updateEvaluacion({commit},payload){
            commit('cambioJsonEvaluacion',payload)
        },
        updateNotasEvaluacion({commit},payload){
            commit('updateNotasEvaluacion',payload)
        },
        updateEstadoNota({commit},payload){
            commit('cambioJsonEstadoNota',payload)
        },
        updateReinicioNota({commit},payload){
            commit('updateReinicioNota',payload)
        }
    },
    getters:{
       
    }
}